<template>
<v-app id="inspire">
  <v-container style='margin-top: 5%;'>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols='12' sm='8' md='6' lg='4' align='center'>
        <v-img
          :src="myImage"
          width='100%'>
        </v-img>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row><v-col></v-col></v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="elevation-12" style='padding: 3% 5% 3% 3%'>
          <v-card-text>
            <v-form>
              <v-text-field
                label="Usuario"
                v-model="usuario"
                name="login"
                prepend-icon="mdi-account"
                type="text"
              ></v-text-field>

              <v-text-field
                id="password"
                v-model="password"
                label="Contraseña"
                name="password"
                prepend-icon="mdi-lock"
                @keypress.enter="login()"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPass ? 'text' : 'password'"
                @click:append="showPass = !showPass"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="goRegistro()" text small>Registrarse</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="login()" :disabled="awaitingResponse" color="primary">Ingresar</v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-spacer></v-spacer>
            <a style='font-size: 10pt' @click='$router.push({name: "CambiarPassword"})'>¿Olvidaste tu contraseña?</a>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</v-app>
</template>

<script>
  import { consoleErrorMessage, toasterErrorMessage } from '@/utils/responseCatchMessages.js';
  export default {
    data(){
      return {
        myImage: require('@/assets/firmatyaRectangulo.png'),
        usuario: '',
        password: '',
        clienteId: '',
        currentUser: {},
        awaitingResponse: false,
        showPass: false,
      }
    },
    props: {
      source: String,
    },
    mounted(){
      this.currentUser = this.$store.getters.getClient;
      //console.log("USER:%o", this.currentUser);
      if(this.currentUser.username){
        this.$router.push({name: 'Menu'});
      }
    },
    methods: {
      async login() {
        const defaultToastMessage = 'Error de login.';
        const defaultConsoleMessage = 'login error';
        try {
          this.awaitingResponse = true;
          const username = this.usuario;
          const password = this.password;
          const result = await this.$store.dispatch('login',{username, password});
          //console.log("LOGIN:%o", result);
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            this.stopWait();
            return;
          }
          //this.$store.dispatch('setToken', result);
          //this.$router.push({name: 'Menu'});
        }catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
        this.stopWait();
      },
      goRegistro() {
        this.$router.push({name: 'Registro'});
      },
      stopWait() {
        var self = this;
        window.setTimeout((obj) => { obj.awaitingResponse = false; }, 500, self);
      },
    },
  };
</script>